import { useContext, useState, useEffect } from "react";
import { UserContext } from "../context/UserProvider";
import Swal from 'sweetalert2';
import { Navigate } from "react-router-dom";
import { Api } from "../componentes/Api";
import { Card, Col, Row, CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap";
import validator from 'validator';
import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import moment from "moment";


const modeloUsuario = {
    idUsuario: 0,
    empresaID: 0,
    nombre: "",
    correo: "",
    telefono: "",
    idRol: 4,
    clave: "",
    dgii: "",

    esActivo: true
}
const Login = () => {

    const [_correo, set_Correo] = useState("")
    const [_clave, set_Clave] = useState("")
    const { user, iniciarSession } = useContext(UserContext)
    const [usuario, setUsuario] = useState(modeloUsuario);

    const [roles, setRoles] = useState([]);
    const [verModal, setVerModal] = useState(false);
    const [verLogin, setLogin] = useState(false);
    const [Reg, setReg] = useState(true);
    const [ListaEmpr, SetListaEmpr] = useState([]);
    const [emailError, setEmailError] = useState('');
    const [Listado, SetListado] = useState([]);
    const [currentMonth, setCurrentMonth] = useState(new Date());
    const [selectedDate, setSelectedDate] = useState(null);
    const [showForm, setShowForm] = useState(false);


    useEffect(() => {
        obtenerDatos(); // Se ejecuta al inicio

        const intervalo = setInterval(() => {
            obtenerDatos();
        }, 3000); // 3000 ms = 3 segundos

        return () => clearInterval(intervalo); // Limpieza
    }, []);

 const cells = buildCalendar(currentMonth);; // Se ejecuta al inicio
    useEffect(() => {
       

        const intervalo = setInterval(() => {
            buildCalendar(currentMonth) 
        }, 3000); // 3000 ms = 3 segundos

        return () => clearInterval(intervalo); // Limpieza
    }, []);

    
    const [citas, setCitas1] = useState([]); // {id, dateKey, paciente, hora, nota}
 

    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_0hli5un', 'template_ixkbi04', form.current, 'lQQs5pUGa38VFF5KU')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });
    };




    if (user != null) {
        return <Navigate to="/"/>
    }

    const handleSubmit = (event) => {
        event.preventDefault();
      
        let request = {
            correo: _correo,
            clave:_clave
        }

        const api = fetch(Api+"session/Login", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify(request)
        })
            .then((response) => {
                
            return response.ok ? response.json() : Promise.reject(response);
        })
        .then((dataJson) => {
            if (dataJson.idUsuario == 0) {
                Swal.fire(
                    'Opps!',
                    'No se encontro el usuario',
                    'error'
                )
            } else {
                dataJson.clave = dataJson.dgii;
                iniciarSession(dataJson)
            }

        }).catch((error) => {
            Swal.fire(
                'Opps!',
                'No se pudo iniciar sessión',
                'error'
            )
        })
    }

    const handleChange = (e) => {

        console.log(e.target.value)

        let value;

        if (e.target.name == "idRol") {
            value = e.target.value
        } else if (e.target.name == "esActivo") {
            value = (e.target.value == "true" ? true : false)
        } else {
            value = e.target.value;
        }

        if (e.target.name == "correo" && validator.isEmail(value)) {
            setEmailError('')

            ValidarCorreo(value);


            setReg(false);
        } else {
            if (e.target.name == "correo") {
                setEmailError('Entre un email valido!');
            setReg(true);
        }
        }
        setUsuario({
            ...usuario,
            [e.target.name]: value
        })
    }

    const ValidarCorreo = async (x) => {
        let response1 = await fetch(Api + "Usuario/ValidarUsuario" + "/" + x);
        if (response1.ok) {
            let data1 = await response1.json()
            Swal.fire(
                'Opps!',
                'El correo que registrar existe. Intente con otra cuenta',
                'error'
            )

        }
    }

    const guardarCambios = async () => {

        delete usuario.idRolNavigation;
        usuario.empresaID = parseInt(usuario.empresaID);
        let response;
        if (usuario.idUsuario == 0 && usuario.clave != "" && usuario.nombre != "") {
            response = await fetch(Api + "usuario/GuardarRegistro", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(usuario)
            })

        } else {
            response = await fetch(Api + "", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(usuario)
            })
        }

        if (response.ok) {
           
            Swal.fire(
                'Cuenta Creada, Ya puedes iniciar!',
                'Las credenciales de su cuenta fueron enviada al correo '+ usuario.correo,
                'success'
            )
            setVerModal(!verModal);

        } else {
            alert("Faltan Campos por llenar.")
        }

       
    }

    function formatKey(date) {
        return date.toISOString().split("T")[0]; // 2025-12-05
    }

    function isSameDay(a, b) {
        return formatKey(a) === formatKey(b);
    }

    function buildCalendar(currentMonth) {
        const year = currentMonth.getFullYear();
        const month = currentMonth.getMonth();
        const firstDay = new Date(year, month, 1);
        const startingWeekDay = firstDay.getDay(); // 0 = domingo
        const daysInMonth = new Date(year, month + 1, 0).getDate();

        const cells = [];
        // huecos antes del 1
        for (let i = 0; i < startingWeekDay; i++) {
            cells.push(null);
        }
        // días reales del mes
        for (let d = 1; d <= daysInMonth; d++) {
            cells.push(new Date(year, month, d));
        }
        // completar hasta múltiplo de 7
        while (cells.length % 7 !== 0) {
            cells.push(null);
        }
        return cells;
    }


 

    const handlePrevMonth = () => {
        setCurrentMonth(
            new Date(
                currentMonth.getFullYear(),
                currentMonth.getMonth() - 1,
                1
            )
        );
    };

    const handleNextMonth = () => {
        setCurrentMonth(
            new Date(
                currentMonth.getFullYear(),
                currentMonth.getMonth() + 1,
                1
            )
        );
    };

    const handleDayClick = (day) => {
        if (!day) return;
        setSelectedDate(day);

        //  setShowForm(true);
     //   tabla.fechaCirugia = day
        setVerModal(!verModal)
    };

 

    const obtenerDatos = async () => {
        let response = await fetch(Api + "Citas/ListaFechaCirugiaDisponible" );
        if (response.ok) {
            let data = await response.json()
            SetListado(data)

        }
    }

  
    const countCitas = (day) => {
        if (!day) return 0;
        const key = formatKey(day);
        return Listado.filter((c) => moment(c.fechaCirugia).format("YYYY-MM-DD") === key).map(x => x.cantidad)[0];
        // return citas.filter((c) => c.dateKey === key).length;
    };

    const TipoDiaF = (day) => {
        if (!day) return 0;
        const key = formatKey(day);
        return Listado.filter((c) => moment(c.fechaCirugia).format("YYYY-MM-DD") === key).map(x => x.tipoDia)[0];
        // return citas.filter((c) => c.dateKey === key).length;
    }; 

    const citasDelDia = selectedDate
        ? citas.filter((c) => c.dateKey === formatKey(selectedDate))
        : [];

    const monthLabel = currentMonth.toLocaleString("es-ES", {
        month: "long",
        year: "numeric",
    });


    return (
        <div className="container">
            <div style={{width:"200px"} }>    {(verLogin) ? <button onClick={() => setLogin(!verLogin)} type="submit" className="btn btn-primary btn-user btn-block">Ver Calendario  </button>
               : <button onClick={() => setLogin(!verLogin)} type="submit" className="btn btn-primary btn-user btn-block"> Iniciar Seccion </button>}

            </div>
            <div className="calendar-wrapper" style={{ color: "#000" }} hidden={verLogin }>
                <div className="calendar-header">
                    <button onClick={handlePrevMonth} >{"<"}</button>
                    <h3 style={{ textTransform: "uppercase" }}>{monthLabel}</h3>
                    <button onClick={handleNextMonth}>{">"}</button>
                </div>

                <div className="calendar-weekdays">
                    {["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"].map((d) => (
                        <div key={d} className="weekday">
                            {d}
                        </div>
                    ))}
                </div>

                <div className="calendar-grid" style={{ color: "#000" }}>
                    {cells.map((day, idx) => {
                        const numCitas = day ? countCitas(day) : 0;
                        const TipoD = day ? TipoDiaF(day) : "Normal";

                        //const numCitas = day ? countCitas(day) : 0;
                        return (
                            <button
                                key={idx}
                                className={`calendar-day ${day ? "" : "empty"}`}
                             //   onClick={() => handleDayClick(day)}
                                disabled={!day}

                            >
                                {day && (
                                    <>
                                        <span className="day-number" style={{ color: "#000" }}>{day.getDate()}</span>
                                        {(numCitas > 0)? (
                                            (TipoD === "Festivo" || TipoD === "Congreso") ? <div className="citas-chip">
                                                <small>{TipoD}</small>
                                            </div> : <div className="citas-chip">
                                                <span>{numCitas}{day.cantidadCitas}</span>
                                                <small>citas</small>
                                            </div>
                                        
                                        ):""}
                                    </>
                                )}
                            </button>
                        );
                    })}
                </div>
                </div>

         


            <div className="row justify-content-center" hidden={!verLogin}>

                <div className="col-xl-10 col-lg-12 col-md-9">

                    <div className="card o-hidden border-0 shadow-lg my-5">
                        <div className="card-body p-0">

                            <div className="row">
                                <div className="col-lg-6 d-none d-lg-block bg-login-image">
                                    <img class="card-img-top" src="./imagen/LogoApatech.png" style={{ width: '80%', height: '86%' }} />
                                </div>
                                <div className="col-lg-5">
                                    <div className="p-5">
                                        <div className="text-center">
                                            <h1> APATECH TOOLS</h1> 
                                            <h1 className="h4 text-gray-900 mb-4" style={{backgroundColor:"#fff"} }>Bienvenido</h1>
                                        </div>
                                        <form className="user" onSubmit={handleSubmit}>
                                            <div className="form-group">
                                                <input type="text" className="form-control form-control-user"  placeholder="Usuario"
                                                    value={_correo}
                                                    onChange={(e) => set_Correo(e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <input type="password" className="form-control form-control-user" placeholder="Contraseña"
                                                    value={_clave}
                                                    onChange={(e) => set_Clave(e.target.value)}
                                                />
                                            </div>
                                            <button type="submit" className="btn btn-primary btn-user btn-block"> Ingresar </button>
                                            
                                        </form>
                                        <hr></hr>
                                        <a class="btn" color="success" size="sm" onClick={() => setVerModal(true)}>Registrarse </a>


                                    </div>
                                </div>
                            </div>
                        </div>
                </div>

                </div>

            </div>

            <Modal isOpen={verModal}>
                <ModalHeader className=" modal-header1">
                   Creación de nueva cuenta
                </ModalHeader>
                <form ref={form} onSubmit={sendEmail}>
                    <ModalBody>
                   
                    <Row>
                        <Col sm={6}>
                            <FormGroup>
                                <span style={{ color: 'red', }}>*</span>     <Label>Nombre</Label>
                                <Input bsSize="sm" name="nombre" onChange={handleChange} value={usuario.nombre} />
                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup>
                                <span style={{ color: 'red', }}>*</span>
                                <Label>Correo</Label>

                                <Input bsSize="sm"  name="correo" onChange={handleChange} value={usuario.correo} />
                            
                                <span style={{
                                    fontWeight: 'bold',
                                    color: 'red',
                                }}>{emailError}</span>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <FormGroup>
                                 <Label>Telefono</Label>
                                <Input bsSize="sm" type="number" name="telefono" onChange={handleChange} value={usuario.telefono} />
                            </FormGroup>
                        </Col>
                 
                        <Col sm="6" >
                            <FormGroup>
                                <span style={{ color: 'red', }}>*</span>  <Label>Contraseña</Label>
                                <Input bsSize="sm" name="clave" onChange={handleChange} value={usuario.clave} type="password" />
                            </FormGroup>
                        </Col>

                       
                        {/*<Col sm="4" >*/}
                        {/*    <FormGroup>*/}
                        {/*        <Label>Estado</Label>*/}
                        {/*        <Input bsSize="sm" type={"select"} name="esActivo" onChange={handleChange} value={usuario.esActivo} >*/}
                        {/*            <option value={true}>Activo</option>*/}
                        {/*            <option value={false}>No Activo</option>*/}
                        {/*        </Input>*/}
                        {/*    </FormGroup>*/}
                        {/*</Col>*/}
                    </Row>
                    <p class="terminos">La creacion de esta cuenta solo tendra acceso al modulo de registro de NCF.</p>
                       
                </ModalBody>
                <ModalFooter>
                        <Button hidden={Reg} type="submit" value="Send"  size="sm" color="primary" onClick={guardarCambios}>Registrarme</Button>
                    <Button size="sm" class="btn "onClick={()=>setVerModal(false)}>Cancelar</Button>
                </ModalFooter> </form>
            </Modal>

        </div>

        )
}

export default Login